// @helpers
const { APIGet } = require('utilities/APIRequestHelper');

// @constants
const actionTypes = require('../constants/actionTypes');

const lavandaRequest = () => ({
    type: actionTypes.LAVANDA_CARDS_REQUEST,
});

const lavandaSuccess = (data = {}) => ({
    type: actionTypes.LAVANDA_CARDS_SUCCESS,
    payload: {
        cards: data,
    }
});

const lavandaFailure = (error) => ({
    type: actionTypes.LAVANDA_CARDS_FAILURE,
    payload : { error }
});

const lavandaReset = () => ({
    type: actionTypes.LAVANDA_CARDS_RESET,
});

const getLavandaCards = () => (dispatch) => {
    dispatch(lavandaRequest());

    return APIGet({
        dispatch,
        endpoint: 'lavandaCards',
        params: {
            header: {
                version: 2
            },
        }
    })
        .then(response => dispatch(lavandaSuccess(response)))
        .catch(({error}) => dispatch(lavandaFailure(error)));
};

module.exports = {
    getLavandaCards,
    lavandaReset,
};